import { render, staticRenderFns } from "./DictionariesList.vue?vue&type=template&id=0112d800&scoped=true&"
import script from "./DictionariesList.vue?vue&type=script&lang=js&"
export * from "./DictionariesList.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesList.vue?vue&type=style&index=0&id=0112d800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0112d800",
  null
  
)

export default component.exports